import React, { useState, useEffect, useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useNavigate } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
//   import "assets/stripe.css";
import { useRazorpay } from "react-razorpay";
import logo from "../../../assets/img/illustrations/falcon.png";
import {
  applyPromoCode,
  createOrderIdAction,
  subscriptionStatusAction,
  createOrderIdClearAction,
  setSubscriptions,
  createStaticIPOrderIdAction,
  createStaticIPRenewalOrderIdAction,
  staticIPPaymentStatusAction,
  staticIPRenewalStatusAction,
  clearSubscriptionStatus
} from "../../../redux/actions/packageAction";
import BrokerService from "../../../services/broker.service";
import Store from "../../../redux";

import { getprofile } from "../../../api/authentication";
import {
  removeKeyLocalStorageObject,
  setLocalStorageObject,
  getLocalStorageObject,
} from "../../../util/helper";
import SoftBadge from "../../../components/common/SoftBadge";
import { settings } from "../../../config";
import '../../../assets/stripe.css'
import { useToast } from "components/common/custom-toast/Toast";

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedPlan, setselectedPlan] = useState([]);
  const [isApplyPromo, setIsApplyPromo] = useState(false);
  const [promoCode, setPromocode] = useState("");
  const [activeItem, setActiveItem] = useState([]);
  const [userInfo, setuserInfo] = useState({});
  const [hasProcessedOrder, setHasProcessedOrder] = useState(false);
  const location = useLocation();

  const suscriptionOrder = useSelector(
    (state) => state.packages.suscriptionOrderId
  );
  const suscriptionStatus = useSelector(
    (state) => state.packages.suscriptionStatus
  );

  const promoCodeData = useSelector(
    (state) => state.packages.promoCodeData
  );
  const toast = useToast()

  useEffect(() => {
    return () => {
      if (dispatch && createOrderIdClearAction) {
        dispatch(createOrderIdClearAction());
      }
      dispatch(clearSubscriptionStatus());
    };
  }, []);

  useEffect(() => {
    async function getUserInfo() {
      const data = await getprofile();
      if (data?.code === 200) {
        setuserInfo(data.data);
      } else {
        navigate("/authentication/login");
      }
    }
    getUserInfo();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (suscriptionOrder && !hasProcessedOrder) {
      setHasProcessedOrder(true);
      handlePayment(suscriptionOrder);
    }
  }, [suscriptionOrder, hasProcessedOrder]);

  useEffect(() => {
    if (promoCodeData) {
      if (isApplyPromo) {
        // Re-render with the new array

        //setPackages(nextShapes);
        if (promoCodeData.isValidPromo) {
          const nextShapes = promoCodeData?.plans?.filter(
            (shape) => shape.packageId == activeItem.id
          );
          if (nextShapes.length <= 0) {
            let msg =
              "Promo code " +
              promoCode.toUpperCase() +
              " not valid for the seleted Plan ";
            toast.error(msg);
            return false;
          }
          setselectedPlan(prevPlan => ({
            ...prevPlan,
            disfinalPrice: nextShapes[0].finalPrice,
            disgst: nextShapes[0].gst
          }));
          let msg =
            "Promo code " + promoCode.toUpperCase() + " applied successfully. ";
          toast.success(msg);
          //  createOrderId(selectedPlan);
        } else {
          toast.error("Promo code " + promoCode.toUpperCase() + " not valid. ");
        }
      }
    }
  }, [promoCodeData, isApplyPromo]);


  const promoCodeInput = (e) => {
    const { name, value } = e.target;

    setPromocode(value);
  };
  const applyPromocodes = async (item) => {
    if (item.planName === 'QT-Add-Broker') {
      toast.error("Promo code not valid for this plan.")
      return;
    }
    setActiveItem(item);
    let parma = {
      packageId: item.id,
      productType: "qt-new",
      promoCode: promoCode.toUpperCase(),
    };

    var data = await dispatch(applyPromoCode(parma));
    if (data?.isValidPromo) {
      const isValid = data?.plans?.filter(
        (shape) => shape.packageId == item.id
      );
      if (isValid.length > 0) {
        setIsApplyPromo(true);
      } else {
        let msg =
          "Promo code " +
          promoCode.toUpperCase() +
          " not valid for the seleted Plan ";
        toast.error(msg);
        return false;
      }
    } else {
      toast.error("Promo code not valid.");
    }
  };
  const createOrderId = (item) => {
    setHasProcessedOrder(false);
    if (!item) {
      toast.error("Plan not found. Please try again.");
      return;
    }
    if (item.planType === 'Static IP') {
      let parma = {
        planId: item.id || "SIP01",
        count: item.additionalBrokerCount || 1,
      };
      dispatch(createStaticIPOrderIdAction(parma));
    } else if (item.planType === 'Static IP Renewal') {
      let parma = {
        userIpId: item.userIpId,
        planId: item.planId || "SIP01",
      };
      dispatch(createStaticIPRenewalOrderIdAction(parma));
    } else {
      let parma = {
        packageId: item.id,
        promoCode: promoCode.toUpperCase(),
        path: window.location.host,
        productType: "qt-new",
        amount: Math.round(subtotalWithAddOn * 100),
        gst: Math.round(gstAmount * 100),
        accounts: addOnUnit
      };
      dispatch(createOrderIdAction(parma));
    }
  };

  const { Razorpay } = useRazorpay();

  function getSubscriptions() {
    BrokerService.getSuscriptions().then(
      response => {
        if (response.code === 200 && response?.data && response?.data?.payments) {
          const jsonData = response?.data?.payments;
          dispatch(setSubscriptions(jsonData));
        } else {
          console.error('Invalid API response:', response);
        }
      },
      error => {
        console.error('API error:', error);
      }
    );
  };

  useEffect(() => {
    const plandata = location.state?.selectedPlan;
    if (suscriptionStatus && (suscriptionStatus.subscriptionValidTill || suscriptionStatus === "success")) {
      const isRenewal = plandata?.planType?.toLowerCase().includes("renewal");
      const planName = plandata?.planName || "Subscription";
      toast.success(`Success! Your ${planName} has been ${isRenewal ? 'renewed' : 'activated'}.`);
      BrokerService.loginStatusCheck().then(
        (response) => {
          if (response.code == 403) {
            navigate("/authentication/login");
            return;
          } else {
            setLocalStorageObject(
              "user",
              "brokerLoggedIn",
              response.data.brokerLoggedIn,
              getLocalStorageObject("user")
            );
            setTimeout(() => {
              navigate("/home");
            }, 500);
          }
        },
        (error) => { }
      );
      getSubscriptions();
    }
  }, [suscriptionStatus]);

  useEffect(() => {
    const plandata = location.state?.selectedPlan;
    if (plandata) {
      setselectedPlan({ ...plandata, disfinalPrice: 0 });
    } else {
      navigate("/pricing");
    }
  }, []);

  const monthsCount = selectedPlan?.numberOfDays
    ? selectedPlan.numberOfDays / 30
    : 1;
  const isAddBrokerPlan = selectedPlan?.planName === 'QT-Add-Broker';

  const originalTotal = isAddBrokerPlan ? 0 : (selectedPlan?.price || 0);
  const netPrice = isAddBrokerPlan ? 0 : (selectedPlan?.costPerDay || 0);
  const baseDiscount = isAddBrokerPlan ? 0 : Math.max(originalTotal - netPrice, 0);
  const promoDiscountApplied = isApplyPromo ? Math.max(netPrice - (selectedPlan?.disfinalPrice || 0), 0) : 0;
  const priceAfterDiscount = isAddBrokerPlan ? 0 : (isApplyPromo ? (selectedPlan?.disfinalPrice || 0) : netPrice);
  const addOnUnit = selectedPlan?.additionalBrokerCount || 0
  const addOnTotal = +(selectedPlan?.addOnTotalPrice || 0);
  const subtotalWithAddOn = priceAfterDiscount + addOnTotal;
  const gstAmount = +(subtotalWithAddOn * 0.18).toFixed(2);
  const totalPayable = Math.floor(subtotalWithAddOn + gstAmount);


  const initiateSubscription = () => {
    createOrderId(selectedPlan);
  };

  const handlePayment = useCallback(
    (suscriptionOrder) => {
      const options = {
        key: "rzp_test_5qys9g2i5Pu32a",
        // key: "rzp_live_tnwPb9vq4ppwZr",
        currency: suscriptionOrder.currency,
        name: suscriptionOrder.name,
        description: suscriptionOrder.description,
        image: { logo },
        //order_id: order.id,
        order_id: suscriptionOrder.order_id,
        prefill: {
          name: suscriptionOrder.prefill.name,
          email: suscriptionOrder.prefill.email,
          contact: suscriptionOrder.prefill.contact,
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: () => {
            if (createOrderIdClearAction) {
              dispatch(createOrderIdClearAction());
            }
            setHasProcessedOrder(false);
          }
        }
      };

      options.handler = (res) => {
        let parma = {
          razorpayPaymentId: res.razorpay_payment_id,
          razorpayOrderId: res.razorpay_order_id,
          razorpaySignature: res.razorpay_signature,
          promoCode: promoCode.toUpperCase(),
        };

        if (suscriptionOrder.isStaticIP) {
          const userId = suscriptionOrder.prefill.userId || Store?.getState()?.user?.userID;
          if (suscriptionOrder.isRenewal) {
            dispatch(staticIPRenewalStatusAction(parma, userId));
          } else {
            dispatch(staticIPPaymentStatusAction(parma, userId));
          }
        } else {
          dispatch(subscriptionStatusAction(parma));
        }

        if (createOrderIdClearAction) {
          dispatch(createOrderIdClearAction());
        }
      };

      const rzpay = new Razorpay(options);
      rzpay.open();
    },
    [Razorpay, dispatch, promoCode]
  );

  return (
    <>
      <div id="paymentpage-container">
        <div id="desktop-container">
          <div className="content-container">
            <div className="content">
              <div id="header-details" className="payment-header-main">
                <div id="header-logo">
                  <img
                    alt="merchant-logo"
                    src="https://cdn.razorpay.com/logos/KhB1aui9bdCT7A_large.jpg"
                  />
                </div>
                <div id="merchant-name">FNOTrader.com</div>
              </div>
              <div className="payment-div">
                <div id="details-view" className="me-5">
                  <div id="details-section">
                    <div id="description-details">
                      <div className="title title--big">
                        Plan Details & Price Breakup
                        {/* <span className="package-name">{packageName}</span> */}
                        <div className="title-underline"></div>
                      </div>

                      <div id="description" className="details-value text-line">
                        <div
                          id="description-quill"
                          className="ql-container ql-snow ql-disabled"
                        >
                          <div
                            className="ql-editor"
                            data-gramm="false"
                            contenteditable="false"
                          >
                            {/* <h2 className="package-name">Price Breakup</h2> */}
                            {/* {suscriptionOrder.packageId === "3-day-plan" && (
                                <p>
                                  Includes access to all features of the page for
                                  - 3 Days Validity
                                </p>
                              )}
                              {suscriptionOrder.packageId === "1-month-plan" && (
                                <p>
                                  Includes access to all features of the page for
                                  - 30 Days Validity
                                </p>
                              )}
                              {suscriptionOrder.packageId === "6-month-plan" && (
                                <p>
                                  Includes access to all features of the page for
                                  - 6 Month Validity
                                </p>
                              )}
                              {suscriptionOrder.packageId === "Professional" && (
                                <p>
                                  Includes access to all features of the page for
                                  - 1 Year Validity
                                </p>
                              )} */}

                            <table className="table  table-bordered">
                              <thead>
                                <tr>
                                  <th scope="col">Product</th>
                                  <td scope="col" className="text-center">
                                    {selectedPlan?.planName?.split("-")[0] == "QT" ? "QuikTrade" : "Discover"}
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col">Plan Name</th>
                                  <td scope="col" className="text-center">
                                    {selectedPlan?.active == 0
                                      ? selectedPlan?.planType?.split(" ")[1]
                                      : selectedPlan?.planName}
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th>Validity</th>
                                  <td className="text-center">
                                    {selectedPlan?.numberOfDays} Days
                                  </td>
                                </tr>
                                {!isAddBrokerPlan && (
                                  <>
                                    <tr>
                                      <th>Original Price</th>
                                      <td className="text-end">
                                        <b className="currency-symbol">₹{originalTotal.toFixed(2)}</b>
                                      </td>
                                    </tr>

                                    {isApplyPromo && (
                                      <tr>
                                        <th>Promo Discount</th>
                                        <td className="text-end">
                                          -
                                          <b className="currency-symbol">
                                            ₹{promoDiscountApplied.toFixed(2)}
                                          </b>
                                        </td>
                                      </tr>
                                    )}

                                    <tr>
                                      <th>
                                        Total Discount
                                        <SoftBadge
                                          bg="success"
                                          size="sm"
                                          className="ms-2 soft-ba"
                                          pill
                                        >
                                          You Saved {originalTotal > 0 ? Math.floor(((baseDiscount + promoDiscountApplied) / originalTotal) * 100) : '0.00'}%
                                        </SoftBadge>
                                      </th>
                                      <td className="text-end">
                                        -
                                        <b className="currency-symbol">₹{(baseDiscount + promoDiscountApplied).toFixed(2)}</b>
                                      </td>
                                    </tr>

                                    <tr>
                                      <th>Net Price</th>
                                      <td className="text-end">
                                        <b className="currency-symbol">₹{priceAfterDiscount.toFixed(2)}</b>
                                      </td>
                                    </tr>
                                  </>
                                )}
                                {selectedPlan?.additionalBrokerCount > 0 && (
                                  <tr>
                                    <th>
                                      Add-on (per broker) × {selectedPlan?.additionalBrokerCount}
                                    </th>
                                    <td className="text-end">
                                      <b className="currency-symbol">₹{addOnTotal.toFixed(2)}</b>
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th>GST (18%)</th>
                                  <td className="text-end">
                                    <b className="currency-symbol">₹{gstAmount.toFixed(2)}</b>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Final Price You Pay</th>
                                  <td className="text-end">
                                    <b className="currency-symbol">₹{totalPayable.toFixed(2)}</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div slot="after">
                              <div id="form-footer" className=" prmo-box">
                                <div className="form-group form-footer-payment">
                                  <Row className="g-1">
                                    <Col xs={12} sm={6} md={7} lg={8}>
                                      <input
                                        type="text"
                                        name={"plan"}
                                        placeholder="PromoCode"
                                        className="form-control"
                                        value={promoCode}
                                        style={{ height: "100%", fontSize: '1rem' }}
                                        onChange={promoCodeInput}
                                      />
                                    </Col>
                                    <Col xs={12} sm={6} md={5} lg={4}>
                                      <button
                                        type="button"
                                        className="btn btn-danger w-100 "
                                        style={{ padding: "7px" }}
                                        disabled={!promoCode.trim()}
                                        onClick={() =>
                                          applyPromocodes(selectedPlan)
                                        }
                                      >
                                        Apply
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>

                            {/* <ul>
                                <li>Real Time Analysis</li>
                                <li>Orderflow Charting</li>
                                <li>Orderflow Analytics</li>
                                <li>Futures Analysis</li>
                                <li>Option Analysis</li>
                                <li>Trade with broker API</li>
                              </ul>
                              <p>and much more coming soon</p>
                              <p></p>
                              <h2>New Features added at no extra cost.</h2> */}
                          </div>
                          <div
                            className="ql-clipboard"
                            contenteditable="true"
                            tabindex="-1"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-view-id="1" id="main-view" className="slider-view">
                  <div className="title">
                    <a
                      slot="before"
                      href="#"
                      className="back-btn"
                      type="button"
                    ></a>
                    Payment Details
                    <div className="title-underline"></div>
                  </div>

                  <div id="form-section" className="">
                    <div className="UI-form" novalidate="">
                      <div>
                        <div className="Field Field--required Field--amount Field--amount--selected Field--currency-1">
                          <div className="Field-label">Amount</div>
                          <div className="Field-content">
                            <div className="Field-wrapper">
                              <span className="Field-addon Field-addon--before">
                                <span>
                                  {" "}
                                  <b className="currency-symbol">₹</b>
                                </span>
                              </span>
                              <div className="Field-el">
                                <label>
                                  {totalPayable.toFixed(2)}
                                </label>
                              </div>
                              <span className="Field-addon Field-addon--after">
                                {" "}
                              </span>
                            </div>
                            <div className="Field-error"></div>
                          </div>
                        </div>
                        <div className="Field Field--required">
                          <div className="Field-label">Email</div>
                          <div className="Field-content">
                            <div className="Field-wrapper">
                              <span className="Field-addon"></span>
                              <input
                                className="Field-el"
                                name="email"
                                required=""
                                type="text"
                                value={userInfo?.email}
                                readOnly
                              />
                              <span className="Field-addon"></span>
                            </div>
                            <div className="Field-error"></div>
                            <div className="Field-description"></div>
                          </div>
                        </div>
                        <div className="Field Field--required">
                          <div className="Field-label">Phone</div>
                          <div className="Field-content">
                            <div className="Field-wrapper">
                              <span className="Field-addon"></span>
                              <input
                                className="Field-el"
                                name="phone"
                                required=""
                                type="tel"
                                minlength="8"
                                value={userInfo?.mobile}
                                readOnly
                              />
                              <span className="Field-addon"></span>
                            </div>
                            <div className="Field-error"></div>
                            <div className="Field-description"></div>
                          </div>
                        </div>
                        <div className="Field Field--required">
                          <div className="Field-label">Name</div>
                          <div className="Field-content">
                            <div className="Field-wrapper">
                              <span className="Field-addon"></span>
                              <input
                                className="Field-el"
                                name="name"
                                required=""
                                type="text"
                                value={
                                  userInfo?.firstName + " " + userInfo?.lastName
                                }
                                readOnly
                              />
                              <span className="Field-addon"></span>
                            </div>
                            <div className="Field-error"></div>
                            <div className="Field-description"></div>
                          </div>
                        </div>
                      </div>
                      <div slot="after">
                        <div id="form-footer" className="">
                          <div className="form-footer-payment">
                            <img
                              id="fin-logo"
                              alt="pay-methods"
                              src="https://cdn.razorpay.com/static/assets/pay_methods_branding.png"
                              width="180"
                              height="10"
                            />

                            <button
                              type="button"
                              className="btn btn--gradient"
                              onClick={initiateSubscription}
                            >
                              Pay ₹{totalPayable.toFixed(2)}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="details-view" className="contac-us-d">
                <div id="support-details">
                  <label>Contact Us:</label>
                  <div className="sub-detail">
                    <a
                      href="mailto:Krish@mail.fnotrader.com?subject=Query for Payment Page Id: pl_KhAtnrtR0FfXgZ"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                      </svg>
                      <div>{settings?.supportEmail}</div>
                    </a>
                  </div>

                  <div className="sub-detail">
                    <a href="tel:8971995467">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>
                      </svg>
                      <div>{settings?.phone}</div>
                    </a>
                  </div>
                </div>
                <div id="terms-details">
                  <label>Terms &amp; Conditions:</label>
                  <div className="details-value text-wrap">
                    <div className="terms-details-tnc">
                      You agree to the{" "}
                      <Link to="/terms-condition">terms & conditions</Link> and{" "}
                      <Link to="/refund-policy">refund policy</Link> mentioned
                      here.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;